import { InventoryAddComponent } from '@agence/locataire/inventory/inventory-add/inventory-add.component';
import { InventoryShowComponent } from '@agence/locataire/inventory/inventory-show/inventory-show.component';
import { InventoryUploadComponent } from '@agence/locataire/inventory/inventory-upload/inventory-upload.component';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { InventoryService } from '@service/inventory/inventory.service';
import { DateHelperService } from '@theme/utils/date-helper.service';
import { VALIDATION } from '@theme/utils/functions';
import { Globals } from '@theme/utils/globals';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-inventory-customer',
  templateUrl: './inventory-customer.component.html',
  styleUrls: ['./inventory-customer.component.scss']
})
export class InventoryCustomerComponent implements OnInit {

  @Input() inventories = [];
  @Input() locataire: true;
  @Input() validate: boolean = false
  @Input() action: boolean = true;
  dtOptions: any = {};
  etat: string = 'bon état' // Valeur par défaut définie comme 'bon état'
  global = {country: Globals.country, device: Globals.device}
  userSession = Globals.user
  validation = VALIDATION

  dataSelected: any[] = [];
  form: FormGroup;

  constructor(
    private modalService: NgbModal,
    private formBuild: FormBuilder,
    private inventoryService: InventoryService,
    private emitter: EmitterService,
  ) { 
    this.newForm()
  }

  ngOnInit(): void {
    // Gardez la logique existante si nécessaire, sinon la valeur par défaut sera 'bon état'
    // this.etat = this.inventories ? true : false; // Ancienne logique commentée
    this.dtOptions = Globals.dataTable;
    this.emitter.event.subscribe((data) => {
      if (data.action === 'INVENTORY_ADD') {
        this.appendToList(data.payload);
      }
      if (data.action === 'INVENTORY_UPDATED') {
        this.update(data.payload);
      }
      if (data.action === 'PAYMENT_VALIDATE') {
        const row = data.payload
        const index = this.inventories.findIndex(x => x.id === row.id);
        if (index !== -1) { this.inventories.splice(index, 1); }
      }
    });
  }

  newForm(): void {
    this.form = this.formBuild.group({
      valueOne:[null],
      checked: [null],
      checkedAll: this.formBuild.array([]),
      etat: [this.etat] // Ajout du champ état avec la valeur par défaut
    });
  }

  appendToList(item): void {
    this.inventories.unshift(item);
  }
  update(item): void {
    const index = this.inventories.findIndex(x => x.uuid === item.uuid);
    if (index !== -1) {
      this.inventories[index] = item;
    }
  }
  addInventory() {
    this.modalService.dismissAll();
    this.inventoryService.edit = false;
    this.modal(InventoryAddComponent, 'modal-basic-title', 'xl', true, 'static');
  }
  editInventory(row) {
    this.inventoryService.setInventory(row);
    this.inventoryService.edit = true;
    this.inventoryService.type = row.type;
    this.modal(InventoryAddComponent, 'modal-basic-title', 'xl', true, 'static');
  }
  showInventory(row) {
    this.inventoryService.setInventory(row);
    this.inventoryService.validated = this.validate
    this.modal(InventoryShowComponent, 'modal-basic-title', 'xl', true, 'static');
  }
  printerInventory(row): void {
    this.inventoryService.getPrinterCustomer('CUSTOMER', this.userSession?.agencyKey, this.userSession?.uuid, row?.uuid);
  }

  
  onConfirme() {
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment valider cet enrégistrement ?',
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Valider <i class="fas fa-check"></i>',
      cancelButtonText: 'Annuler <i class="feather icon-x-circle"></i>',
      confirmButtonColor: '#1bc943',
      reverseButtons: true
    }).then((willDelete) => {
      if (!willDelete.dismiss) {
         this.onSubmit();
      }
    });
  }

  onSubmit() {
    if (this.form.valid) {
      this.dataSelected.forEach((item) => {
        this.checkedAll.push(
          this.formBuild.group({
            uuid: [item?.uuid],
          })
        );
      });
      this.inventoryService.validate(this.form.getRawValue()).subscribe((res) => {
        if (res?.status === 'success') {
          res?.data.forEach((payload) => {
            this.emitter.emit({action: 'INVENTORY_VALIDATE', payload:payload});
          });
        }
    });
    
    } else {
      return;
    }
  }

  validateInventory(row){
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment valider cet enrégistrement ?',
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Valider <i class="fas fa-check"></i>',
      confirmButtonColor: 'green',
      timer: 2500,
      reverseButtons: true
    }).then((willDelete) => {
      if (willDelete.dismiss) {
      } else {
        this.checkedAll.push(
          this.formBuild.group({
            uuid: [row?.uuid],
          })
        );
      this.inventoryService.validate(this.form.getRawValue()).subscribe(res => {
        if (res?.status === 'success') {
          res?.data.forEach((payload) => {
            this.emitter.emit({action: 'INVENTORY_VALIDATE', payload:payload});
          });
        }
   
      });
      }
    });
  }
  uploadInventory(row): void {
    this.inventoryService.setInventory(row);
    this.modal(InventoryUploadComponent, 'modal-basic-title', 'md', true, 'static');
  }
  formatDate(date) { return DateHelperService.fromJsonDate(date); }
  delete(item) {
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment supprimer cet enrégistrement ?',
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Supprimer <i class="feather icon-trash"></i>',
      confirmButtonColor: '#d33',
      timer: 2500,
      reverseButtons: true
    }).then((willDelete) => {
      if (willDelete.dismiss) {
      } else {
        this.inventoryService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.code === 200) {
            const index = this.inventories.findIndex(x => x.uuid === item.uuid);
            if (index !== -1) {
              this.inventories.splice(index, 1);
            }
            Swal.fire('', res?.message, res?.status);
          }
        });
      }
    });
  }
  modal(component, type, size, center, backdrop) {
    this.modalService.open(component, {
      ariaLabelledBy: type,
      size: size,
      centered: center,
      backdrop: backdrop
    }).result.then((result) => { }, (reason) => { });
  }

  get checkedAll() { return this.form.get('checkedAll') as FormArray; }

}